<template>
  <transition name="fade">
    <div v-if="getModal" id="modal" class="popup__wrapper popup__add-user popup__add d-flex" @mousedown="getModal != 'ModalTestMessage' ? $store.dispatch('closeModal', $event) : false">
      <ModalUser v-if="getModal === 'ModalUser'"/>
      <ModalUserCurrent v-if="getModal === 'ModalUserCurrent'"/>

      <ModalCreateQuestion v-if="getModal === 'ModalCreateQuestion'"/>
      <ModalSurveyQuestion v-if="getModal === 'ModalSurveyQuestion'"/>
      <ModalSelectSurveyQuestion v-if="getModal === 'ModalSelectSurveyQuestion'"/>

      <ModalTestQuestion v-if="getModal === 'ModalTestQuestion'"/>
      <ModalTestMessage v-if="getModal === 'ModalTestMessage'"/>

      <ModalCountry v-if="getModal === 'ModalCountry'"/>
      <ModalPesticide v-if="getModal === 'ModalPesticide'"/>
      <ModalActiveIngredient v-if="getModal === 'ModalActiveIngredient'"/>
      <ModalCrop v-if="getModal === 'ModalCrop'"/>
      <ModalPest v-if="getModal === 'ModalPest'"/>
      <ModalOrganSystem v-if="getModal === 'ModalOrganSystem'"/>

      <ModalMap v-if="getModal === 'ModalMap'"/>
    </div>
  </transition>
</template>

<script>
  import ModalUser from './ModalUser'
  import ModalUserCurrent from './ModalUserCurrent'

  import ModalCreateQuestion from './ModalCreateQuestion'
  import ModalSurveyQuestion from './ModalSurveyQuestion'
  import ModalSelectSurveyQuestion from './ModalSelectSurveyQuestion'

  import ModalTestQuestion from './ModalTestQuestion'
  import ModalTestMessage from './ModalTestMessage'

  import ModalCountry from './ModalCountry'
  import ModalPesticide from './ModalPesticide'
  import ModalActiveIngredient from './ModalActiveIngredient'
  import ModalCrop from './ModalCrop'
  import ModalPest from './ModalPest'
  import ModalOrganSystem from './ModalOrganSystem'

  import ModalMap from './ModalMap'

  import {mapGetters} from 'vuex'

  export default {
    name: 'Modal',
    components: {
      ModalUser,
      ModalUserCurrent,

      ModalCreateQuestion,
      ModalSurveyQuestion,
      ModalSelectSurveyQuestion,

      ModalTestQuestion,
      ModalTestMessage,

      ModalCountry,
      ModalPesticide,
      ModalActiveIngredient,
      ModalCrop,
      ModalPest,
      ModalOrganSystem,

      ModalMap,
    },
    computed: {
      ...mapGetters([
        'getModal'
      ])
    }
  }
</script>